import { useEffect, useRef, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import AutoScroll from "embla-carousel-auto-scroll";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { getNovaDeal } from "@/api/admin";

export function NovaPartnerCarousel() {
  const [emblaRef] = useEmblaCarousel(
    { loop: true, dragFree: true, align: "start" },
    [AutoScroll({ speed: 1, stopOnInteraction: false, stopOnMouseEnter: false, stopOnFocusIn: false })]
  );

  const { ref: headerRef, visible: headerVisible } = useScrollReveal(0.1);

  const sectionRef = useRef<HTMLElement>(null);
  const [sectionVisible, setSectionVisible] = useState(false);
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => { if (entries[0]?.isIntersecting) { setSectionVisible(true); observer.disconnect(); } },
      { threshold: 0.05 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const [partners, setPartners] = useState<{ name: string; logo: string }[]>([]);
  useEffect(() => {
    getNovaDeal()
      .then(deals => setPartners(deals.map(d => ({ name: d.name, logo: d.image_url }))))
      .catch(() => {});
  }, []);

  return (
    <section ref={sectionRef} className="w-full pb-20 overflow-hidden">
      <div
        ref={headerRef}
        className="transition-all duration-700"
        style={{
          opacity: headerVisible ? 1 : 0,
          transform: headerVisible ? 'translateY(0)' : 'translateY(32px)',
        }}
      >
        <h2 className="text-3xl font-bold text-white text-center mb-3 font-roboto">
          Δες τα αποκλειστικά προνόμια
        </h2>
        <p className="text-white/50 text-center mb-12 px-4">
          Που εξασφάλισε για σένα το PADU μαζί με τη <span className="text-[#00d9d9] font-semibold">Nova</span>.
        </p>
      </div>

      <div
        className="transition-opacity duration-1000"
        style={{ opacity: sectionVisible ? 1 : 0, transitionDelay: '200ms' }}
      >
        <div
          className="w-[1128px] mx-auto mb-12 overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_0%,black_99%,transparent)]"
          ref={emblaRef}
        >
          <div className="flex gap-8 px-8">
            {partners.map((p) => (
              <div
                key={p.name}
                className="shrink-0 w-80 aspect-square flex flex-col rounded-2xl border border-[#00d9d9]/20 bg-[#111] overflow-hidden hover:border-[#00d9d9]/50 transition-colors duration-300"
              >
                <div className="relative flex-1 min-h-0 bg-white flex items-center justify-center">
                  <img src={p.logo} alt={p.name} className="w-full h-full object-contain" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#111] via-transparent to-transparent" />
                </div>
                <div className="px-4 py-3 flex items-center justify-between shrink-0">
                  <span className="text-white/80 text-xs font-bold tracking-wide">{p.name}</span>
                  <span className="text-[9px] font-bold text-[#00d9d9] uppercase tracking-widest bg-[#00d9d9]/10 border border-[#00d9d9]/30 rounded-full px-2.5 py-1">
                    Nova Deal
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
